import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-gray-600 body-font h-screen bg-white w-full mx-auto" }
const _hoisted_2 = { class: "container px-5 py-24 mx-auto grid place-items-center" }
const _hoisted_3 = { class: "w-full md:w-1/3 rounded-lg p-8 mt-10 inline-block" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-semibold text-gray-800 uppercase title-font mb-5 text-center" }, " Dashboard - Transparência ", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Entrar ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Fazendo login, aguarde... ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://anctecnologia.com.br",
  class: "bottom-0"
}, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-600 text-sm no-underline" }, " ANC Tecnologia da Informação ")
], -1)
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Scaneie o QR Code com o aplicativo Google Authenticator e preencha o codigo abaixo ")
const _hoisted_10 = {
  key: 2,
  class: "grid place-content-center mb-5"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=pt_BR&gl=US"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://assets.zoom.us/generic-images/misc/google-play-badge.png",
    alt: "Google Authenticator",
    class: "h-16"
  })
], -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_n_spin = _resolveComponent("n-spin")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_n_space, { vertical: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_n_spin, {
              show: _ctx.state.isLoading
            }, {
              description: _withCtx(() => [
                _hoisted_6
              ]),
              default: _withCtx(() => [
                _createVNode(_component_n_form, {
                  ref: "formRef",
                  "label-width": 80,
                  model: _ctx.form,
                  rules: _ctx.rules,
                  size: "medium",
                  class: "gap-y-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_form_item, {
                      label: "Email",
                      path: "email"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_input, {
                          value: _ctx.form.email,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event)),
                          type: "text",
                          placeholder: "Digite seu email",
                          clearable: "",
                          onKeyup: _ctx.state.clearError
                        }, null, 8, ["value", "onKeyup"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_n_form_item, {
                      label: "Senha",
                      path: "password"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_input, {
                          value: _ctx.form.password,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
                          type: "password",
                          placeholder: "Digite sua senha",
                          clearable: "",
                          onKeyup: _ctx.state.clearError
                        }, null, 8, ["value", "onKeyup"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_n_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_button, {
                          class: "w-full",
                          onClick: _ctx.login,
                          type: "info"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _: 1
            }, 8, ["show"])
          ]),
          _: 1
        })
      ]),
      _hoisted_7
    ]),
    _createVNode(_component_n_modal, {
      show: _ctx.showModalOtpStore,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showModalOtpStore) = $event)),
      "mask-closable": false,
      preset: "dialog",
      title: "Código de verificação",
      "positive-text": "Confirmar",
      "negative-text": "Cancelar",
      onPositiveClick: _ctx.setOtpCode
    }, {
      default: _withCtx(() => [
        (_ctx.state.qrCode != null && _ctx.state.qrCode != undefined)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.state.qrCode,
              alt: "QR Code",
              class: "w-full h-auto mx-auto"
            }, null, 8, _hoisted_8))
          : _createCommentVNode("", true),
        (_ctx.state.qrCode != null && _ctx.state.qrCode != undefined)
          ? (_openBlock(), _createBlock(_component_n_alert, {
              key: 1,
              title: "Instruções",
              type: "info",
              class: "mb-5"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.state.qrCode != null && _ctx.state.qrCode != undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
          : _createCommentVNode("", true),
        _createVNode(_component_n_input, {
          value: _ctx.state.otpCode,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.otpCode) = $event)),
          type: "text",
          placeholder: "Número OTP"
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["show", "onPositiveClick"])
  ]))
}